import type { JSX } from 'react';

import { Banner } from 'src/app/shared/components/banners/layout';

export function EmergencyBannerContainer({ emergencyBanner }: { emergencyBanner: string }): JSX.Element {
	return <Banner mobileContent={emergencyBanner} desktopContent={emergencyBanner} />;
}
